<p-table
	[value]="rows"
	[paginator]="rows.length > 5"
	[rows]="5"
	[loading]="loading"
	[showCurrentPageReport]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
>
	<ng-template pTemplate="header">
		<tr>
			<th>Hotel Name</th>
			<th>Audit Completion Rate</th>
			<th>Most Efficient Group</th>
			<th>Av. Days to Audit</th>
			<th>Action</th>
		</tr>
	</ng-template>

	<!-- Skeleton rows while loading -->
	<ng-template pTemplate="loadingbody">
		<tr *ngFor="let i of [1,2,3,4,5]">
			<td>
				<p-skeleton width="65%" height="1.1rem"></p-skeleton>
			</td>
			<td>
				<p-skeleton width="4.8rem" height="1.6rem" styleClass="radius-pill"></p-skeleton>
			</td>
			<td>
				<p-skeleton width="9rem" height="1.6rem" styleClass="radius-chip"></p-skeleton>
			</td>
			<td>
				<p-skeleton width="7rem" height="1.1rem"></p-skeleton>
			</td>
			<td class="action">
				<p-skeleton width="1.6rem" height="1.6rem" styleClass="radius-circle"></p-skeleton>
			</td>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-row>

<ng-container>
	<tr>
		<td>{{ row.hotelName }}</td>
		<td>
  <span class="pill pill--blue">
		{{ row.auditCompletionRate | number : '1.0-0' }}%
  </span>
		</td>

		<td>
  <span class="chip chip--green">
		{{ row.mostEfficientGroup ?? '-' }}
  </span>
		</td>

		<td>
  <span class="metric metric--good" [title]="rawDays(row.avgDaysToAudit)">
		{{ row.avgDaysToAudit | durationFromDays:{ showMinutes: false } }}
  </span>
		</td>


		<td class="action">

<button
	pButton
type="button"
class="p-button-text chevron-toggle"
	[icon]="isExpanded(row.propertyId) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
(click)="toggleExpand(row.propertyId); $event.stopPropagation()"
	[attr.aria-expanded]="isExpanded(row.propertyId)"
aria-label="Toggle staff breakdown"
></button>
	</td>
	</tr>

<tr class="drawer-row" *ngIf="isExpanded(row.propertyId)">
	<td colspan="5">
<app-performance-hotel-staff-inline-drawer
		[hotelName]="row.hotelName"
	[rows]="staffRows(row.propertyId)"
></app-performance-hotel-staff-inline-drawer>
	</td>
	</tr>
		</ng-container>
	</ng-template>

	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="5" class="empty">
				No data available for the selected range.
			</td>
		</tr>
	</ng-template>
</p-table>
